export default __webpack_public_path__ + "b1238fb7eda76106bcfacd66eeefcaa7.svg";